module.exports = __webpack_public_path__ + "img/sala.f39b5211.svg";